<template>

    <div class="author_list">
        <div class="keyFigures_col appearEffect">
            <h3 v-if="expertTitle" class="author_list_title" v-html="expertTitle"></h3>
            <Author v-for="(expert, index) in experts"
                :title="expert.title"
                :name="expert.name"
                :quote="expert.quote"
                :image="expert.image"
                :anchor="expert.anchor"
                :key="index"
            >
            </Author>
        </div>
    </div>

</template>



<script>
    import Author from "./Author";
    export default {
        name: 'AuthorList',
        components: {Author},
        props: {
            experts: {
                type: Array,
                default: [],
            },
            expertTitle: {
                type: String,
                default: "",
            }
        },
    };
</script>

<style scoped lang="scss">

.author_list {
    padding-top: $G-default;
    .author {
        padding-bottom: $G-default;
    }


    &_title {
        font-size: 2.2rem;
        font-weight: $FW-semibold;
        margin: $G-default/3 0 $G-default/1.5 0;
    }
}

</style>